import { render } from "./SimplePlanChange.vue?vue&type=template&id=57df4832&scoped=true&lang=pug"
import script from "./SimplePlanChange.vue?vue&type=script&lang=js"
export * from "./SimplePlanChange.vue?vue&type=script&lang=js"

import "./SimplePlanChange.vue?vue&type=style&index=0&id=57df4832&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57df4832"]])

export default __exports__